<template>
  <div class="flex flex-col items-center justify-center w-full h-full">
    <Feedback
      v-if="showFeedback"
      :game="game"
      :user="user"
      @close="showFeedback = false"
    />
    <div
      v-if="saveStatus === 'pending'"
      class="w-10/12 p-3 my-6 text-white bg-green-700 rounded-lg shadow-lg dark:text-dark-900 md:w-3/4 lg:w-2/3"
    >
      <h1 class="py-3 text-3xl font-heading">Saving Result</h1>
      <p class="pb-2">Please Wait</p>
    </div>

    <div
      v-if="saveStatus === 'failed'"
      class="w-10/12 p-3 my-6 text-white bg-red-700 rounded-lg shadow-lg dark:text-dark-900 md:w-3/4 lg:w-2/3"
    >
      <h1 class="py-3 text-3xl font-heading">Problem Saving Result</h1>
      <p class="pb-2">
        Please Take A Note Of Your Score And Email It To
        orienteeringunlocked@gmail.com
      </p>
    </div>

    <h1 class="text-5xl font-heading">Well Done!</h1>

    <h3 v-if="score" class="text-2xl font-semibold font-main">
      Score: {{ score }}<span v-if="scoreIsTime">s</span>
    </h3>
    <h3
      v-if="time && !scoreIsTime && !disableTime"
      class="text-2xl font-semibold font-main"
    >
      Time: {{ (time / 1000).toFixed(2) }}s
    </h3>
    <div v-if="saveStatus !== 'pending'">
      <div v-if="!routeQuery.redirect" class="mt-6">
        <router-link
          v-if="$route.params.id"
          to="./../"
          class="mt-3 button-secondary"
          >Return to Game Home</router-link
        >
        <router-link v-else to="./" class="mt-3 button-secondary"
          >Return to Game Home</router-link
        >
        <router-link to="/" class="mt-3 button-secondary"
          >Return Home</router-link
        >
        <a
          v-if="saveStatus !== ''"
          href="https://www.maprunner.co.uk/lockdown-results/"
          class="mt-3 button-secondary"
          >View Results</a
        >
        <button
          v-if="game && user"
          href="https://www.maprunner.co.uk/lockdown-results/"
          class="mt-3 button"
          @click="showFeedback = true"
        >
          Leave a Comment
        </button>
      </div>
      <div v-else class="mt-6">
        <router-link :to="routeQuery.redirect" class="mt-3 button-secondary"
          >Back</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import Feedback from '@/components/Feedback'

export default {
  components: {
    Feedback,
  },

  props: {
    score: {
      type: String,
      default: '',
    },
    time: {
      type: Number,
      default: 0,
    },
    disableTime: {
      type: Boolean,
      default: false,
    },
    scoreIsTime: {
      type: Boolean,
      default: false,
    },
    routeQuery: {
      type: Object,
      default: () => ({}),
    },
    saveStatus: {
      type: String,
      default: '',
    },
    game: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    showFeedback: false,
  }),
}
</script>
